//@ts-nocheck
import * as yup from "yup";

let LoginFormValidationSchema = yup.object().shape({
  email: yup.string().email().required("Email is required"),
  password: yup.string().required("Password is required"),
});

let forgetPasswordValidationForm = yup.object().shape({
  email: yup.string().email().required("Email is required"),
});
let confirmPasswordResetValidationForm = yup.object().shape({
  otp: yup.number().required("OTP is required"),
  password: yup.string().required("Required"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords don't match!")
    .required("Required"),
});

let updateBusinessProfile = yup.object().shape({
  company: yup.string().required("Company name is required"),
  currency: yup.string().required("Currency is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  email: yup.string().required("Primary Email is required"),
  timezone: yup.string().required("Timezone is required"),
  country: yup.string().required("Country is required"),
  address: yup.string().required("Address is required"),
});

let updateWebsiteSetting = yup.object().shape({
  company: yup.string().required("Company name is required"),
  currency: yup.string().required("Currency is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  email: yup.string().required("Primary Email is required"),
  timezone: yup.string().required("Timezone is required"),
  country: yup.string().required("Country is required"),
  address: yup.string().required("Address is required"),
});

let statusValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
  priority: yup.number().required("Priority is required"),
  color: yup.string().required("Charge is required"),
});

let countryValidationForm = yup.object().shape({
  name: yup.string().required("Country Name is required"),
});

let stateValidationForm = yup.object().shape({
  name: yup.string().required("State Name is required"),
  parent: yup.string().required("Country is required"),
});

let districtValidationForm = yup.object().shape({
  name: yup.string().required("State Name is required"),
  country: yup.string().required("Country  is required"),
  parent: yup.string().required("State is required"),
});
let cityValidationForm = yup.object().shape({
  name: yup.string().required("City Name is required"),
  code: yup.string().required("Code is required"),
  country: yup.string().required("Country  is required"),
  state: yup.string().required("State  is required"),
  parent: yup.string().required("District is required"),
});

let productTypeValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
});

let branchValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
  primary_email: yup.string().email().required("Primary Email is required"),
  secondary_contact: yup.string().required("Secondary Contact"),
  primary_contact: yup.string().required("Primary Contact is required"),
  branch_manager: yup.string().required("Branch manager is required"),
  landmark: yup.string().required("Landmark is required"),
  warehouse: yup.string().required("Warehouse is required"),
});

let warehouseValidationForm = yup.object().shape({
  name: yup.string().required("Warehouse Name is required"),
  primary_email: yup.string().email().required("Primary Email is required"),
  secondary_contact: yup.string().required("Secondary Contact"),
  primary_contact: yup.string().required("Primary Contact is required"),
  warehouse_manager: yup.string().required("Warehouse manager is required"),
  landmark: yup.string().required("Landmark is required"),
});

let createTicketValidationForm = yup.object().shape({
  queue: yup.string().required("Subject is required"),
  priority: yup.string().required("Priority is required"),
  description: yup.string().required("Description is required"),
});
let createClientSupportValidationForm = yup.object().shape({
  subject: yup.string().required("Subject is required"),
  priority: yup.string().required("Priority is required"),
  description: yup.string().required("Description is required"),
});

let createUserValidationForm = yup.object().shape({
  user: yup.string().required("Full Name is required"),
  delivery_charge_template: yup
    .string()
    .required("Delivery Charge Template is required"),
});

let createManifestValidationForm = yup.object().shape({
  vehicle: yup.string().required("Vehicle is required"),
  driver: yup.string().required("Driver is required"),
  destination_branch: yup.string().required("Branch is required"),
});

let createStaffValidationForm = yup.object().shape({
  email: yup.string().email().required("Email is required"),
  mobile_number: yup.number().required("Mobile Number is required"),
  full_name: yup.string().required("Full Name is required"),
  designation: yup.string().required("Designation is required"),
  full_address: yup.string().required("Address is required"),
});

let createCustomerValidationForm = yup.object().shape({
  full_name: yup.string().required("Email is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  address: yup.string().required("Address is required"),
});

let createRiderValidationForm = yup.object().shape({
  user: yup.string().required("User is required"),
  license_number: yup.string().required("License Number is required"),
  citizen_ship_number: yup.string().required("Citizenship Number is required"),
});
let createDeliveryChargeValidation = yup.object().shape({
  pickup_branch: yup.string().required("Pickup Branch is required"),
  destination_city: yup.string().required("Destination City is required"),
  base_weight: yup.string().required("Base weight is required"),
  base_price: yup.string().required("Base price is required"),
  price_for_exceed_weight: yup
    .string()
    .required("Price of exceed weight is required"),
});

let setupBranchValidationForm = yup.object().shape({
  branch: yup.string().required("Branch is required"),
});

let changePasswordValidationForm = yup.object().shape({
  password: yup.string().required("Password is required"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords don't match!")
    .required("Required"),
});

let editOrderValidationForm = yup.object().shape({
  is_walking_customer: yup.boolean(),
  // sender_full_name: yup.string().when("is_walking_customer", {
  //   is: true,
  //   then: yup.string()
  //     .required('Phone number is required.'),
  // }),
  // sender_mobile_number: yup.string().when("is_walking_customer", {
  //   is: true,
  //   then: yup.string()
  //     .required('Sender Phone number is required.'),
  // }),
  pickup_branch: yup.string().required("Pickup branch is required"),
  destination_branch: yup.string().required("Destination branch is required"),
  // merchant: yup.string().when("is_walking_customer", {
  //   is: false,
  //   then: yup.string()
  //     .required('Merchant is required.'),
  // }),
  customer_full_name: yup
    .string()
    .required("Customer full address is required"),
  customer_full_address: yup
    .string()
    .required("Customer ful address is required"),
  customer_mobile_number1: yup
    .string()
    .required("Customer mobile number is required"),
  // weight: yup.string().required("Weight is required"),
  // delivery_charge: yup.string().required("Delivery Charge is required....."),
  package_type: yup.string().required("Package type is required"),
  delivery_instruction: yup
    .string()
    .required("Delivery Instruction is required"),
  cod: yup.number().required("Cod is required"),
});

let orderRemarksValidationForm = yup.object().shape({
  comment: yup.string().required("Remarks is required"),
});

let createDeliveryChargeTemplateValidation = yup.object().shape({
  name: yup.string().required("Name is required"),
});

let paymentValidationForm = yup.object().shape({
  payment_method: yup.string().required("Payment method is required"),
});

let merchantOrderValidationForm = yup.object().shape({
  merchant: yup.string().required("Merchant is required"),
});

let merchantDeliveryChargeTemplateValidationForm = yup.object().shape({
  delivery_charge_template: yup
    .string()
    .required("Delivery Charge Tempate is required"),
});

let uploadOrderExcelFileValidationForm = yup.object().shape({
  file: yup.mixed().test("required", "Excel File is required", (file) => {
    if (file?.length) return true;
    return false;
  }),
});

let roleValidationForm = yup.object().shape({
  role: yup.string().required("Name is required"),
});

let createUserServiceValidationForm = yup.object().shape({
  username: yup.string().required("Username is required"),
  email: yup.string().email().required("Email is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  password: yup.string().required("Password is required"),
  confirm_password: yup.string().required("Confirm Password is required"),
});

let vehicleValidationForm = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .required("Emergency Contact Number is required"),
  license_number: yup.string().required("License Number is required"),
});

export {
  LoginFormValidationSchema,
  forgetPasswordValidationForm,
  updateBusinessProfile,
  statusValidationForm,
  countryValidationForm,
  stateValidationForm,
  districtValidationForm,
  cityValidationForm,
  productTypeValidationForm,
  branchValidationForm,
  warehouseValidationForm,
  createUserValidationForm,
  createDeliveryChargeValidation,
  confirmPasswordResetValidationForm,
  setupBranchValidationForm,
  changePasswordValidationForm,
  editOrderValidationForm,
  orderRemarksValidationForm,
  merchantOrderValidationForm,
  paymentValidationForm,
  createDeliveryChargeTemplateValidation,
  merchantDeliveryChargeTemplateValidationForm,
  createStaffValidationForm,
  createRiderValidationForm,
  createTicketValidationForm,
  uploadOrderExcelFileValidationForm,
  updateWebsiteSetting,
  roleValidationForm,
  createUserServiceValidationForm,
  vehicleValidationForm,
  createManifestValidationForm,
  createCustomerValidationForm,
  createClientSupportValidationForm,
};
